var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-list',{attrs:{"mode":"ios"}},[_c('ion-item',{staticClass:"cursor-pointer",attrs:{"lines":"inset"},on:{"click":function($event){return _vm.addNewPracticeUser()}}},[_c('ion-label',{attrs:{"mode":"ios"}},[_vm._v("Add New Practice User")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }